module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.f33df36.eot";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0
// module id = 740
// module chunks = 85